import React, { useEffect, useState, useMemo } from 'react';
import moment from 'moment';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { useNavigate, useParams } from 'react-router-dom';
import { LinkIcon, CloseIcon, PlusIcon, DeleteIcon } from 'ui-component/custom-icons/icons';
import DeleteConfirmation from 'ui-component/confirmation-dialogs/deleteConfirmation/DeleteConfirmation';
import { Skeleton, Tooltip } from '@mui/material';
import usePageTitle from 'hooks/usePageTitle';
import usePermissions from 'hooks/usePermissions';
import ShipmentTrackingModal from 'ui-component/confirmation-dialogs/awbModal/ShipmentTrackingModal';
import ActionConfirmationModal from 'ui-component/confirmation-dialogs/actionConfirmationModal/ActionConfirmationModal';
import { PiInfoFill } from 'react-icons/pi';
import { saveAs } from 'file-saver';
import * as XLSX from 'xlsx';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import StatusBadge from 'ui-component/StatusBadge';
import AwbModal from './modals/AwbModal';
import PicklistComponent from './components/PicklistComponent';
import PdfViewer from 'ui-component/PdfViewer';
import CurrencyValue from 'ui-component/CurrencyValue';
import useIsMobile from 'utils/isMobileUtils';
import { FiTrash2 } from 'react-icons/fi';
import PictureAsPdfOutlinedIcon from '@mui/icons-material/PictureAsPdfOutlined';
import InsertPhotoOutlinedIcon from '@mui/icons-material/InsertPhotoOutlined';
import { LuChevronDown, LuChevronUp } from 'react-icons/lu';

// ✅ Clear
function ShipmentDetails() {
	const { id } = useParams();
    const [setPageTitle] = usePageTitle('Shipment');
    useEffect(() => {
        return () => {
            setPageTitle('Shipment');
        };
    }, []);
	const history = useNavigate();
	const [shippingDetails, setShippingDetails] = useState();
	const [shippingCompanies, setShippingCompanies] = useState();
    const [isLoading, setIsLoading] = useState(true)
    const [allPermissions, hasEveryPermission] = usePermissions();
	const [showTrackingNoModal, setShowTrackingNoModal] = useState(false);
	const [selectedAttachment, setSelectedAttachment] = useState(null);
	const [showDeleteAttachmentPopup, setShowDeleteAttachmentPopup] = useState(false);
	const selectedCurrency = useSelector((state) => state.main.selectedCurrency);
	const [shipmentEventData, setShipmentEventData] = useState([]);
	const [collapseShipmentInformationCard, setCollapseShipmentInformationCard] = useState(true);
	const [collapseOrderInformationCard, setCollapseOrderInformationCard] = useState(false);
	const [collapseAttachmentCard, setCollapseAttachmentCard] = useState(false);
	const [collapseImeiListCard, setCollapseImeiListCard] = useState(false);
	const [collapseStatusUpdatesCard, setCollapseStatusUpdatesCard] = useState(false);
	const [showDeleteDataPopup, setShowDeleteDataPopup] = useState(false);

	const [showAwbModal, setShowAwbModal] = useState(null);

	const getShippingDetails = (callback = () => { }) => {
		api.getShipmentDetails(id).then((res) => {
			if (res?.status) {
				setIsLoading(false)
				setShippingDetails(res.data);
				callback(res.data);
			} else {
				history('/shipments');
			}
		});

	};

	useEffect(() => {

		const events = shippingDetails?.histories?.reduce((acc, event) => {
						const dateKey = event.date;
						if (!acc[dateKey]) acc[dateKey] = [];
						acc[dateKey].push(event);
						return acc;
					}, {});
		if (events !== undefined) {
		
			setShipmentEventData(events);
			console.log('events', events)
		}
	}, [shippingDetails])

	const getShippingCompanies = () => {
		api.getSelectOptionsList('shipping_company').then((res) => {
			const val = res.data.map((item) => ({ id: item.id, name: `${item.name}` }));
			setShippingCompanies(val);
		});
	};

	const handleFormSubmit = (e) => {
		toast.promise(
			api
				.updateShipmentAwb(id, {
					tracking_no: e?.trackingNo,
					shipping_company_id: e?.shippingCompanyId,
					shipment_id: showTrackingNoModal
				})
				.then((res) => {
					if (res.status) {
						getShippingDetails();
						handleCloseShipmentTrackingModal();
					}
				}),
			{
				loading: 'Updating Tracking...',
				success: <b>Tracking Detail updated!</b>,
				error: <b>Could not Update Tracking Detail.</b>
			}
		);
	};

	const [confirmationDialog, setConfirmationDialog] = useState({
		show: false,
		message: '',
		title: '',
		handleConfirm: () => { },
		handleClose: () => { }
	});

	const handleCloseConfirmationDialog = () => {
		setConfirmationDialog({
			show: false,
			message: '',
			title: '',
			handleConfirm: () => { },
			handleClose: () => { }
		});
	};

	const showConfirmationDialog = (
		title,
		message = '',
		onConfirm = () => { },
		onClose = () => {
			handleCloseConfirmationDialog();
		}
	) => {
		setConfirmationDialog({
			show: true,
			message: message,
			title: title,
			handleConfirm: onConfirm,
			handleClose: onClose
		});
	};

	useEffect(() => {
		if (id) {
			getShippingDetails();
			getShippingCompanies();
		}
	}, []);



	const s2ab = (s) => {
		const buf = new ArrayBuffer(s.length);
		const view = new Uint8Array(buf);
		for (let i = 0; i !== s.length; ++i) view[i] = s.charCodeAt(i) & 0xff;
		return buf;
	};

	const handleDownloadImei = (id) => {
		api.downloadShipmentImei(id).then((res) => {
			// Create a workbook
			const wb = XLSX.utils.book_new();
			// Create a worksheet
			const ws = XLSX.utils.json_to_sheet(res?.data);
			XLSX.utils.book_append_sheet(wb, ws, 'Sheet1');

			// Convert the workbook to a binary string
			const wbBinaryString = XLSX.write(wb, { bookType: 'xlsx', type: 'binary' });

			// Convert the binary string to a Blob
			const blob = new Blob([s2ab(wbBinaryString)], { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

			saveAs(blob, `Projectmix Shipment ${shippingDetails?.tracking_number} Serials.xlsx`);
		});
	};
	
	const handleCloseShipmentTrackingModal = (data) => {
		setShowTrackingNoModal('');
	};
	const redirectFunc = (data) => {
		setTimeout(() => {
			history(`/shipments/${id}`);
		}, 1000);
	};

	const exportSerials = () => {
		handleDownloadImei(id)
	}

	const handleClose = () => {
		setShowAwbModal(false);
		setShowDeleteAttachmentPopup(false);
	}

	const handleReloadList = () => {
		getShippingDetails();
		setShowAwbModal(false);
	}

	const handleRemoveAttachment = (data) => {
		setSelectedAttachment(data);
		setShowDeleteAttachmentPopup(true);
	}

	const handleDeleteAttachment = () => {
		toast.promise(
			api.deleteShipmentAttachment(selectedAttachment?.id).then(
				(res) => {
					if (res.status) {
						getShippingDetails();
						handleClose();
					}
					return res?.status ? res : null;
				},
				() => { }
			),
			{
				loading: 'Deleting Attachment...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete attachment</b>
			}
		)
	}
	const deleteData = () => {
		setShowDeleteDataPopup(true);
	}

	const handleDeleteData = () => {
		toast.promise(
			api.deleteShipmentTracking(shippingDetails?.id).then((res) => {
				if (res?.status) {
					handleClose();
					history('/shipments');
				}
				return res?.status ? res : null;
			}),
			{
				loading: 'Deleting Shipment...',
				success: (data) => `${data.message}`,
				error: <b>Failed to delete shipment</b>
			}
		);
	}

	const viewData = (source, id) => {
		if (source === 'shipment') {
			history(`/shipments/${id}`);
		} else if (source === 'picklist') {
			window.open(`/picklists/${id}`, '_blank');
		} else if (source === 'sales_order') {
			window.open(`/sales/sales-orders/${id}`, '_blank');
		} else if (source === 'contact') {
			window.open(`/contacts/${id}`, '_blank');
		} else if (source === 'invoice') {
			window.open(`/sales/invoices/${id}`, '_blank');
		}
	};

	const isMobile = useIsMobile();

	return (
		<>
			<div className="row">
				<div className="col-12">
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<div
								style={{
									position: 'relative',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 8,
									minHeight: 38 // ensures enough height for the button
								}}
							>
								{' '}
								<button
									type="button"
									aria-label="Back"
									onClick={() => history(-1)}
									className="circle-back-btn"
									style={{
										position: 'absolute',
										left: 20,
										top: '50%',
										transform: 'translateY(-50%)'
									}}
								>
									<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
										<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</button>
								<h5
									style={{
										textAlign: 'center',
										flex: 1,
										margin: 0,
										display: 'flex',
										gap: 10,
										justifyContent: 'center',
										alignItems: 'center'
									}}
								>
									Shipping Details
								</h5>
							</div>
							<div style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: '5px' }}>
								<PermissionAllowed permissions={['View Shipment (Button)']} hasSome>
									<button
										type="button"
										onClick={() => {
											const url = `${shippingDetails.tracking_link}`;
											window.open(url, '_blank');
										}}
										className="btn btn-primary btn-outlined-main"
										disabled={isLoading}
									>
										<LinkIcon width="16px" height="16px" />
										Track
									</button>
								</PermissionAllowed>
								<PermissionAllowed permissions={['View Shipment (Button)']} hasSome>
									<button
										type="button"
										onClick={() => exportSerials()}
										className="btn btn-primary btn-outlined-main"
										disabled={isLoading}
									>
										<svg
											id="fi_2767144"
											enable-background="new 0 0 128 128"
											height="18"
											viewBox="0 0 128 128"
											width="18"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												id="Download"
												d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
												fill="currentColor"
											></path>
										</svg>
										Export
									</button>
								</PermissionAllowed>
								<PermissionAllowed permissions={['View Shipment (Button)']} hasSome>
									<button
										type="button"
										onClick={() => {
											deleteData();
										}}
										className="btn btn-primary btn-outlined-main"
										disabled={isLoading}
									>
										<DeleteIcon height="14px" width="14px" />
										Delete
									</button>
								</PermissionAllowed>
							</div>
						</div>
					</div>
					<div className=" hide-on-mobile">

						<div className="shipment-details-header-section ">

							<div className="d-flex align-items-center" style={{ fontSize: '16px', gap: '10px' }}>
								<span className="textGray font-14">
									Tracking Code:
								</span>{' '}
								{isLoading ? (
									<span style={{ width: '150px' }}>
										<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
									</span>
								) : (
									<span>
										{shippingDetails?.tracking_number ?? '---'}
									</span>
								)}
							</div>

							<div className="text-right">
								<div className="btn-group-actions" style={{ display: 'flex', alignItems: 'center', gap: '10px' }}>
									{isLoading ? (
										<>
											<div style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px' }} />
											</div>
											<div style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px' }} />
											</div>
											<div style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px' }} />
											</div>
											<div style={{ width: '100px' }}>
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px' }} />
											</div>
										</>
									) : (
										<>
											<div>
												<StatusBadge itemStatus={shippingDetails?.status ? shippingDetails.status.toUpperCase() : ''} />
											</div>
											<button
												type="button"
												onClick={() => {
													const url = `${shippingDetails.tracking_link}`;
													window.open(url, '_blank');
												}}
												className="btn btn-primary btn-outlined-main"
												disabled={isLoading}
											>
												<LinkIcon width="16px" height="16px" />
												Track
											</button>
											<PermissionAllowed permissions={['View Shipment (Button)']} hasSome>
												<button
													type="button"
													onClick={() => exportSerials()}
													className="btn btn-primary btn-outlined-main"
													disabled={isLoading}
												>
													<svg
														id="fi_2767144"
														enable-background="new 0 0 128 128"
														height="18"
														viewBox="0 0 128 128"
														width="18"
														xmlns="http://www.w3.org/2000/svg"
													>
														<path
															id="Download"
															d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
															fill="currentColor"
														></path>
													</svg>
													Export
												</button>
											</PermissionAllowed>
											<PermissionAllowed permissions={['Delete Shipment (Button)']}>

												<button
													type="button"
													onClick={() => {
														deleteData();
													}}
													className="btn btn-danger flex items-center" 
													style={{ gap: '5px' }}
													disabled={isLoading}
												>
													<DeleteIcon height="14px" width="14px" />
													Delete
												</button>
											</PermissionAllowed>
										</>
									)}
								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div className="row" style={{ padding: !isMobile ? 'auto' : '0 15px'  }}>
				<div className="col-12 col-md-8" style={{ marginTop: '20px' }}>
					<div className={`card ${!isMobile && 'mb20' } ${collapseShipmentInformationCard ? 'shadow-sm' : '' } bg-white mb-2 w-100 border card-border-gray`}>
						<div className={`${collapseShipmentInformationCard ? 'card-header-radius-0' : 'card-header-radius-360'}`} style={{ padding: '0px 10px', background: '#fff' }}>
							<div className="row">
								<div className="col-12">
									<div
										className={`${!isMobile ? 'section-head' : 'styleHeaderSectionMobile' } row`}
										style={{ padding: '0px 10px !important', paddingLeft: '8px', paddingBottom: '8px' }}
										onClick={() => setCollapseShipmentInformationCard(!collapseShipmentInformationCard)}
									>
										<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-md-8 col-10">
											<div className="flex align-items-center" style={{ gap: '10px' }}>
												
												<div className="" style={{ fontSize: '16px' }}>
													Shipment Information
												</div>
											</div>
										</div>
										<div className="actions col-md-4 col-2 flex align-items-center justify-end" style={{ gap: '8px' }}>
											<div className={`invoice-attachment-collapse-icon ${collapseShipmentInformationCard ? 'collapsed' : ''}`}>
												<LuChevronUp />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{collapseShipmentInformationCard && (
							<div className="card-body" style={{ padding: '20px' }}>
								<div className="row">
									<div className="col-12 col-md-6 form-group">
										<div className="text-gray-600">Waybill Number</div>
										<div>
											{isLoading ? (
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											) : (
												<span>
													{shippingDetails?.tracking_number ?? '---'}
												</span>
											)}
										</div>
										
									</div>
									<div className="col-12 col-md-6 form-group">
										<div className="text-gray-600">Status</div>
										<div>
											{isLoading ? (
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											) : (
												<div>
													<StatusBadge itemStatus={shippingDetails?.status ? shippingDetails.status.toUpperCase() : ''} width={'auto'} />
												</div>
											)}
										</div>
									</div>
									<div className="col-12 col-md-6 form-group">
										<div className="text-gray-600">Courier</div>
										<div>
											{isLoading ? (
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											) : (
												<span>
													{shippingDetails?.shipping_company?.name ?? '---'}
												</span>
											)}
										</div>
									</div>
										
									<div className="col-12 col-md-6 form-group">
										<div className="text-gray-600">Sold To</div>
										<div>
											
											{isLoading ? (
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											) : (
												shippingDetails?.shipments?.length > 0 && (
													shippingDetails?.shipments?.map((shipment, index) => (
														<span key={shipment.id}>
															{index > 0 && ', '}
															<span
																className={`${hasEveryPermission(['View Shipment (Button)']) ? 'cursor-pointer text-primary' : ''
																	}`}
																onClick={() => {
																	if (hasEveryPermission(['View Shipment (Button)'])) {
																		viewData('shipment', shipment.id);
																	}
																}}
															>
																{shipment?.receiver?.name}
															</span>
														</span>
													))
												)
											)}

										</div>
									</div>
									<div className="col-12 col-md-6 form-group">
										<div className="text-gray-600">Origin</div>
										<div>
											{isLoading ? (
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											) : (
												<span>
													{shippingDetails?.origin ?? '---'}
												</span>
											)}
										</div>
									</div>
									<div className="col-12 col-md-6 form-group">
										<div className="text-gray-600">Destination</div>
										<div>
											{isLoading ? (
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											) : (
												<span>
													{shippingDetails?.destination ?? '---'}
												</span>
											)}
										</div>
									</div>
									<div className="col-12 col-md-3 form-group">
										<div className="text-gray-600">Qty</div>
										<div>
											{isLoading ? (
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											) : (
												<span>
													{shippingDetails?.quantity ?? '---'}
													{shippingDetails?.quantity && (
														<span>
															{shippingDetails?.quantity > 1 ? ' pcs' : ' pc'}
														</span>
													)}	
												</span>
											)}
										</div>
									</div>
									<div className="col-12 col-md-3 form-group">
										<div className="text-gray-600">Weight</div>
										<div>
											{isLoading ? (
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											) : (
												<span>
													{shippingDetails?.shipments[0]?.weight ? `${shippingDetails?.shipments[0]?.weight} ${shippingDetails?.shipments[0]?.weight_unit}` : '---'}
												</span>
											)}
										</div>
									</div>
									<div className="col-12 col-md-4 form-group">
										<div className="text-gray-600">Shipping Cost</div>
										<div>
											{isLoading ? (
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											) : (
												<span>
													{shippingDetails?.shipments[0]?.shipping_cost ? (
														<CurrencyValue
															currencyObject={shippingDetails?.shipments[0]?.shipping_cost}
															defaultCurrency={
																selectedCurrency.replace(/\s+/g, '') === 'all'
																	? shippingDetails?.currency
																	: selectedCurrency.replace(/\s+/g, '')
															}
														/>
													) : (
														'-----'
													)}
												</span>
											)}
										</div>
									</div>
								</div>
							</div>
						)}
					</div>

					
					<div className={`card ${!isMobile && 'mb20' } ${collapseOrderInformationCard ? 'shadow-sm' : '' } bg-white mb-2 w-100 border card-border-gray`}>
						<div className={`${collapseOrderInformationCard ? 'card-header-radius-0' : 'card-header-radius-360'}`} style={{ padding: '0px 10px', background: '#fff' }}>
							<div className="row">
								<div className="col-12">
									<div
										className={`${!isMobile ? 'section-head' : 'styleHeaderSectionMobile' } row`}
										style={{ padding: '0px 10px !important', paddingLeft: '8px', paddingBottom: '8px' }}
										onClick={() => setCollapseOrderInformationCard(!collapseOrderInformationCard)}
									>
										<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-md-8 col-6">
											<div className="flex align-items-center" style={{ gap: '10px' }}>
												
												<div className="" style={{ fontSize: '16px' }}>
													Order Information
												</div>
											</div>
										</div>
										<div className="actions col-md-4 col-6 flex align-items-center justify-end" style={{ gap: '8px' }}>
											<div className={`invoice-attachment-collapse-icon ${collapseOrderInformationCard ? 'collapsed' : ''}`}>
												<LuChevronUp />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{collapseOrderInformationCard && (
							<div className="card-body" style={{ padding: '20px' }}>
								
								{isLoading ? (
									<div className="row">
										<div className="col-6 col-md-3 form-group">
											<div className="text-gray-600 fw-600 font-14">Sales Order</div>
											<div>
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											</div>
										</div>
										<div className="col-6 col-md-3 form-group">
											<div className="text-gray-600 fw-600 font-14">Invoice</div>
											<div>
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											</div>
										</div>
										<div className="col-6 col-md-3 form-group">
											<div className="text-gray-600 fw-600 font-14">Payment Status</div>
											<div>
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											</div>
										</div>
										<div className="col-6 col-md-3 form-group">
											<div className="text-gray-600 fw-600 font-14">Total</div>
											<div>
												<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
											</div>
										</div>
									</div>
									
								) : (
									shippingDetails?.shipments?.length > 0 ? (
										shippingDetails?.shipments?.map((shipment, index) => (
											<div className="row" key={index}>
												<div className="col-6 col-md-3 form-group">
													<div className="text-gray-600">Sales Order</div>
													<div>
														<span
															className={`${
																hasEveryPermission(['View Sales Orders Details']) ? 'cursor-pointer text-primary' : ''
															}`}
															onClick={() => {
																if (hasEveryPermission(['View Sales Orders Details'])) {
																	viewData('sales_order', shipment?.sales_order?.id);
																}
															}}
														>
															{shipment?.sales_order?.sales_order_number ?? '---'}
														</span>
													</div>
												</div>
												<div className="col-6 col-md-3 form-group">
													<div className="text-gray-600">Invoice</div>
													<div>
														<span
															className={`${
																hasEveryPermission(['View Estimation (Button)']) ? 'cursor-pointer text-primary' : ''
															}`}
															onClick={() => {
																if (hasEveryPermission(['View Estimation (Button)'])) {
																	viewData('invoice', shipment?.invoice?.id);
																}
															}}
														>
															{shipment?.invoice?.invoice_number ?? '---'}
														</span>
													</div>
												</div>
												<div className="col-6 col-md-3 form-group">
													<div className="text-gray-600">Payment Status</div>
													<div>
														<StatusBadge itemStatus={shipment?.invoice?.payment_status === 'Partial' ? 'Open': shipment?.invoice?.payment_status} width={'auto'} />
													</div>
												</div>
												<div className="col-6 col-md-3 form-group">
													<div className="text-gray-600">Total</div>
													<div>
														{shipment?.invoice?.id ? (
															<CurrencyValue
																currencyObject={shipment?.invoice?.converted_currency_total}
																defaultCurrency={
																	selectedCurrency.replace(/\s+/g, '') === 'all'
																		? shipment?.invoice?.currency
																		: selectedCurrency.replace(/\s+/g, '')
																}
															/>
														) : (
															'-----'
														)}
													</div>
												</div>
											</div>
										))
									) : (
										<>
											No Detail Available
										</>		
									)
								)}
							</div>
						)}
					</div>

					
					<div className={`card ${!isMobile && 'mb20' } ${collapseAttachmentCard ? 'shadow-sm' : '' } bg-white mb-2 w-100 border card-border-gray`}>
						<div className={`${collapseAttachmentCard ? 'card-header-radius-0' : 'card-header-radius-360'}`} style={{ padding: '0px 10px', background: '#fff' }}>
							<div className="row">
								<div className="col-12">
									<div
										className={`${!isMobile ? 'section-head' : 'styleHeaderSectionMobile' } row`}
										style={{ padding: '0px 10px !important', paddingLeft: '8px', paddingBottom: '8px' }}
										onClick={() => setCollapseAttachmentCard(!collapseAttachmentCard)}
									>
										<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-md-8 col-6">
											<div className="flex align-items-center" style={{ gap: '10px' }}>
												
												<div className="" style={{ fontSize: '16px' }}>
													Attachments
												</div>
											</div>
										</div>
										<div className="actions col-md-4 col-6 flex align-items-center justify-end" style={{ gap: '8px' }}>
											<div className={`invoice-attachment-collapse-icon ${collapseAttachmentCard ? 'collapsed' : ''}`}>
												<LuChevronUp />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{collapseAttachmentCard && (
							<div className="card-body" style={{ padding: isMobile ? 'auto' : '20px' }}>
								
					
							
								{isLoading ? (
									<Skeleton variant="rounded" width={'100%'} height={60} style={{ borderRadius: '12px'}} />
								) : (
									shippingDetails?.shipments?.length > 0 ? (
										shippingDetails?.shipments?.map((shipment, index) => (
											shipment?.attachments?.length > 0 && (
												shipment?.attachments?.map((attachment, index) => (
													<div
														className="section-head row"
														style={{
															
															paddingLeft: '0px',
															border: '1px solid #c3c3c3',
															paddingBottom: '10px',
															paddingTop: '10px',
															borderRadius: '8px',
															margin: '10px 0'
														}}
													>
														<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-9 col-md-10">
															<div
																className="flex align-items-center text-primary cursor-pointer"
																style={{
																	gap: '10px'
																}}
																onClick={() => {
																	const url = `${attachment.attachment_url}`;
																	window.open(url, '_blank');
																}}
															>
																<div>
																	{(attachment?.extension === 'application/pdf' || attachment?.extension === 'pdf') ? (
																		<PictureAsPdfOutlinedIcon style={{ fontSize: 24 }} />
																	) : (
																		<InsertPhotoOutlinedIcon style={{ fontSize: 24 }} />
																	)}
																</div>
																<div>
																	<div className="">
																		{attachment?.filename}
																	</div>
																	<div className="text-gray-600" style={{ fontSize: '12px' }}>
																		{attachment?.file_size ?? 'Not Available'}
																	</div>

																</div>
															</div>
														</div>
														<div className="actions col-2 flex align-items-center justify-end" style={{ gap: '8px' }}>
															
															<div 
																className="payment-modal-attachment-delete"
																onClick={() => handleRemoveAttachment(attachment)}
																	
															>
																<svg id="Component_127_1" height="12" width="12" data-name="Component 127 – 1" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 19.295 19.289">
																	<path id="Icon_ionic-ios-close" data-name="Icon ionic-ios-close" d="M23.219,20.933l6.891-6.891a1.615,1.615,0,0,0-2.284-2.284L20.935,18.65l-6.891-6.891a1.615,1.615,0,1,0-2.284,2.284l6.891,6.891L11.76,27.825a1.615,1.615,0,1,0,2.284,2.284l6.891-6.891,6.891,6.891a1.615,1.615,0,1,0,2.284-2.284Z" transform="translate(-11.285 -11.289)" />
																</svg>
															</div>
														</div>
													</div>
												))
											)
										))
									) : (
										<div className="text-gray-600" style={{ fontSize: '14px' }}>
											No Attachments Available
										</div>	
									)
								)}	

							</div>
						)}
					</div>

					<div className={`card ${!isMobile && 'mb20' } ${collapseStatusUpdatesCard ? 'shadow-sm' : '' } bg-white mb-2 w-100 border card-border-gray`}>
						<div className={`${collapseStatusUpdatesCard ? 'card-header-radius-0' : 'card-header-radius-360'}`} style={{ padding: '0px 10px', background: '#fff' }}>
							<div className="row">
								<div className="col-12">
									<div
										className={`${!isMobile ? 'section-head' : 'styleHeaderSectionMobile' } row`}
										style={{ padding: '0px 10px !important', paddingLeft: '8px', paddingBottom: '8px' }}
										onClick={() => setCollapseStatusUpdatesCard(!collapseStatusUpdatesCard)}
									>
										<div style={{ alignItems: 'center', fontSize: '14px' }} className="col-md-8 col-6">
											<div className="flex align-items-center" style={{ gap: '10px' }}>
												
												<div className="" style={{ fontSize: '16px' }}>
													Status Updates
												</div>
											</div>
										</div>
										<div className="actions col-md-4 col-6 flex align-items-center justify-end" style={{ gap: '8px' }}>
											<div className={`invoice-attachment-collapse-icon ${collapseStatusUpdatesCard ? 'collapsed' : ''}`}>
												<LuChevronUp />
											</div>
										</div>
									</div>
								</div>
							</div>
						</div>
						{collapseStatusUpdatesCard && (
							<div className="card-body" style={{ padding: '20px' }}>
								
							{
								!isMobile && (
						
									<div className="row">
										<div className="col-12 col-md-3 form-group">
											<div className="text-gray-800 font-14">Time</div>
										</div>
										<div className="col-12 col-md-5 form-group">
											<div className="text-gray-800 font-14">Description</div>
										</div>
										<div className="col-12 col-md-4 form-group">
											<div className="text-gray-800 font-14">Location</div>
										</div>
									</div>
								)
							}
								{isLoading ? (

									[...Array(10)].map((e, i) => (
										<div
											className="row"
											style={{
												borderTop: '1px solid #e0e0e0',
												paddingTop: '10px'
											}}
										>
											<div className="col-12 col-md-3 form-group">
												<div>
													<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
												</div>
											</div>
											<div className="col-12 col-md-5 form-group">
												<div>
													<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
												</div>
											</div>
											<div className="col-12 col-md-4 form-group">
												<div>
													<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
												</div>
											</div>
										</div>
									))
									
								) : (
									shippingDetails?.histories?.length > 0 ? (
										shippingDetails?.histories?.map((history, index) => (
											<div
												className="row"
												key={index}
												style={{
													borderTop: '1px solid #e0e0e0',
    												paddingTop: '10px'
												}}
											>
												<div className="col-12 col-md-3 form-group">
													{
														isMobile ? (
															<div className="flex " style={{ gap: '4px' }}>
																<div className="text-gray-800" style={{ width: '80px', minWidth: '80px' }}>Time</div>
																<div className="fw-400">
																	{history?.date ? moment(history.date).format('DD MMMM YYYY') : '---'}
																</div>
																<div className={`${!isMobile && 'text-gray-600'}`} style={{ fontSize: !isMobile ? '12px' : 'auto' }}>
																	{history?.date_time ? moment(history.date_time).format('dddd, h:mmA') : '---'}
																</div>
															</div>
														) : (
															<>
																<div className="fw-400">
																	{history?.date ? moment(history.date).format('DD MMMM YYYY') : '---'}
																</div>
																<div className="text-gray-600" style={{ fontSize: '12px' }}>
																	{history?.date_time ? moment(history.date_time).format('dddd, h:mmA') : '---'}
																</div>
															</>
														)
													} 
												</div>
												<div className="col-12 col-md-5 form-group">
													{
														isMobile ? (
															<div className="flex " style={{ gap: '4px' }}>
																<div className="text-gray-800" style={{ width: '80px', minWidth: '80px' }}>Description</div>
																<div className="">
																	{history?.description ?? '---'}
																</div>
															</div>
														) : (
															<>
																{history?.description ?? '---'}
															</>
														)
													} 
												</div>
												<div className="col-12 col-md-4 form-group">
													{
														isMobile ? (
															<div className="flex " style={{ gap: '4px' }}>
																<div className="text-gray-800" style={{ width: '80px', minWidth: '80px' }}>Location</div>
																<div className="">
																	{history?.address_locality ?? '---'}
																</div>
															</div>
														) : (
															<>
																{history?.address_locality ?? '---'}
															</>
														)
													} 
												</div>
											</div>
										))
									) : (
										<>
											No Detail Available
										</>		
									)
								)}
							</div>
						)}
					</div>

				</div>
				<div className="col-12 col-md-4">


					<div className="shipment-details-section mb20" style={{ marginTop: !isMobile ? '20px' : '0px' }}>
						<div>

							<div className="row">
								<div className="col-12 mb10" style={{ fontSize: '16px' }}>
									Tracking Timeline
								</div>
							</div>
							<div className="row">
								<div className="col-12">
									{
										isLoading ? (
											<>
												<div className="mb10">
													<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px' }} />
												</div>
												<div class="shipment-timeline">
													{[...Array(10)].map((e, i) => (
														<div class="shipment-timeline-item completed">
															<h3>
																<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px' }} />
															</h3>
															<p style={{ width: '50% '}}>
																<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
															</p>
															<div class="date" style={{ width: '30%'}}>
																<Skeleton variant="rounded" width={'100%'} height={15} style={{ borderRadius: '12px' }} />
															</div>
														</div>
													))}
												</div>
											</>
										) : (
											Object.keys(shipmentEventData).length > 0 ? (
												Object.keys(shipmentEventData).map((date) => (
													<>
														<div className="mb10">{moment(date).format('dddd, DD MMMM YYYY')}</div>
														<div class="shipment-timeline">
															{shipmentEventData[date].map((event, index) => (
																<div class="shipment-timeline-item completed">
																	<h3>{event?.description}</h3>
																	<p>{event?.address_locality}</p>
																	<div class="date">{event?.date_time ? moment(event?.date_time).format('dddd, DD MMM YYYY [at] hh:mmA') : ''}</div>
																</div>
															))}
														</div>
													</>

												))
											) : (
												<div className="text-gray-600" style={{ fontSize: '14px' }}>
													No Logs Available
												</div>
											)
										)
									}


								</div>
							</div>
						</div>
					</div>
				</div>
			</div>
			

				{
					isMobile && (
						<div style={{ height: '80px'} }></div>
					)
				}



			{/* <div className="row">
				<div className="col-xl-12 col-lg-12">
					<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
						<div className="header-bubble" />
						<div className="d-flex flex-column " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
							<div
								style={{
									position: 'relative',
									display: 'flex',
									alignItems: 'center',
									justifyContent: 'center',
									marginBottom: 8,
									minHeight: 38 // ensures enough height for the button
								}}
							>
								{' '}
								<button
									type="button"
									aria-label="Back"
									onClick={() => history(-1)}
									className="circle-back-btn"
									style={{
										position: 'absolute',
										left: 20,
										top: '50%',
										transform: 'translateY(-50%)'
									}}
								>
									<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
										<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
									</svg>
								</button>
								<h5
									style={{
										textAlign: 'center',
										flex: 1,
										margin: 0,
										display: 'flex',
										gap: 10,
										justifyContent: 'center',
										alignItems: 'center'
									}}
								>
									{shippingDetails?.shipping_company?.name}
								</h5>
							</div>
							<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
								<PermissionAllowed permissions={['View Shipment (Button)']} hasSome>
									<button
										type="button"
										onClick={() => exportSerials()}
										className="btn btn-primary btn-outlined-main"
										disabled={isLoading}
									>
										<svg
											id="fi_2767144"
											enable-background="new 0 0 128 128"
											height="18"
											viewBox="0 0 128 128"
											width="18"
											xmlns="http://www.w3.org/2000/svg"
										>
											<path
												id="Download"
												d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
												fill="currentColor"
											></path>
										</svg>
										Export
									</button>
								</PermissionAllowed>
							</div>
						</div>
					</div>
					<div className="section-head-new hide-on-mobile" style={{ marginTop: '10px', paddingLeft: '0' }}>
						<h2 style={{ gap: '5px', fontSize: '18px', marginLeft: '6px' }} className="col-md-4 d-flex items-center">
							{isLoading ? (
								<>
									<div>{shippingDetails?.tracking_number}</div>
									<Tooltip title={'Track order'} arrow placement="right">
										<div className="text-primary cursor-pointer">
											<LinkIcon width="16px" height="16px" />
										</div>
									</Tooltip>
								</>
							) : (
								<>
									<Skeleton variant="rounded" width={'90px'} height={20}></Skeleton>
									<div style={{ width: '75px' }}>
										<Skeleton variant="rounded" width={'100%'} height={20}></Skeleton>
									</div>
								</>
							)}
						</h2>
						<div className="actions">
							<PermissionAllowed permissions={['View Shipment (Button)']} hasSome>
								<button type="button" onClick={() => exportSerials()} className="btn btn-primary btn-outlined-main" disabled={isLoading}>
									<svg
										id="fi_2767144"
										enable-background="new 0 0 128 128"
										height="18"
										viewBox="0 0 128 128"
										width="18"
										xmlns="http://www.w3.org/2000/svg"
									>
										<path
											id="Download"
											d="m128 65c0 15.439-12.563 28-28 28h-20c-2.211 0-4-1.791-4-4s1.789-4 4-4h20c11.027 0 20-8.973 20-20s-8.973-20-20-20h-4c-2.211 0-4-1.791-4-4 0-15.439-12.563-28-28-28s-28 12.561-28 28c0 2.209-1.789 4-4 4h-4c-11.027 0-20 8.973-20 20s8.973 20 20 20h20c2.211 0 4 1.791 4 4s-1.789 4-4 4h-20c-15.437 0-28-12.561-28-28s12.563-28 28-28h.223c1.996-17.975 17.277-32 35.777-32s33.781 14.025 35.777 32h.223c15.438 0 28 12.561 28 28zm-50.828 37.172-9.172 9.172v-50.344c0-2.209-1.789-4-4-4s-4 1.791-4 4v50.344l-9.172-9.172c-1.563-1.563-4.094-1.563-5.656 0s-1.563 4.094 0 5.656l16 16c.781.781 1.805 1.172 2.828 1.172s2.047-.391 2.828-1.172l16-16c1.563-1.563 1.563-4.094 0-5.656s-4.094-1.563-5.656 0z"
											fill="currentColor"
										></path>
									</svg>
									Export
								</button>
							</PermissionAllowed>
						</div>
					</div>
					{isMobile && (
						<div style={{ display: 'flex', justifyContent: 'center', width: '100%', flexDirection: 'column', alignItems: 'center' }}>
							<div>Tracking Number</div>
							<div style={{ display: 'flex', gap: 10 }}>
								<h4>{shippingDetails?.tracking_number}</h4>
								<Tooltip title={'Track order'} arrow placement="right">
									<div className="text-primary cursor-pointer">
										<LinkIcon width="16px" height="16px" />
									</div>
								</Tooltip>
							</div>
						</div>
					)}
					{!isMobile ? (
						<div className="mobile-scroll-container mobile-scroll-container-xsmaller" style={{ paddingTop: 10 }}>
							{shippingDetails?.shipments?.length > 0 && (
								shippingDetails?.shipments?.map((shipment, index) => (
									<div className="row">
										<div className="col-lg-12 form-group">
											<div className="card shadow-sm bg-white mb-4">
												<div className="card-body">
													<div className="parent-group">
														<h5 style={{ fontSize: '16px' }}>
															<span className="textGray" style={{ fontSize: '16px' }}>
																Reference:
															</span>{' '}
															{shipment?.reference_no}
														</h5>

														<div className="text-right" style={{ position: 'absolute', right: '20px' }}>
															<div className="btn-group-actions" style={{ display: 'flex' }}>
																<div style={{ marginRight: '10px', marginTop: '2px' }}>
																	<StatusBadge itemStatus={shippingDetails?.status} />
																</div>
															</div>
														</div>
													</div>
													<hr />
													<div className="row align-items-top">
														<div className="col-md-4 col-12 form-group">
															<div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
																<div className="textGray" style={{ width: '151px' }}>
																	Picklist No
																</div>
																<div style={{ maxWidth: '275px', marginLeft: '10px' }}>
																	{isLoading ? (
																		<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
																	) : (
																		<span
																			className={`${
																				hasEveryPermission(['View Picklists (Button)']) ? 'cursor-pointer text-primary' : ''
																			}`}
																			onClick={() => {
																				if (hasEveryPermission(['View Picklists (Button)'])) {
																					viewData('picklist', shipment?.picklist?.id);
																				}
																			}}
																		>
																			{shipment?.picklist?.picklist_no ?? '-----'}
																		</span>
																	)}
																</div>
															</div>
														</div>
														<div className="col-md-8 col-12 form-group">
															<div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
																<div className="textGray" style={{ width: '151px' }}>
																	Shipping Cost
																</div>
																<div style={{ maxWidth: '275px', marginLeft: '10px' }}>
																	{isLoading ? (
																		<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
																	) : (
																		<span>
																			{shipment?.shipping_cost ? (
																				<CurrencyValue
																					currencyObject={shipment?.shipping_cost}
																					defaultCurrency={
																						selectedCurrency.replace(/\s+/g, '') === 'all'
																							? shippingDetails?.currency
																							: selectedCurrency.replace(/\s+/g, '')
																					}
																				/>
																			) : (
																				'-----'
																			)}
																		</span>
																	)}
																</div>
															</div>
														</div>
													</div>

													<div className="row align-items-top">
														<div className="col-md-4 col-12 form-group">
															<div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
																<div className="textGray" style={{ width: '151px' }}>
																	Sales Order
																</div>
																<div style={{ maxWidth: '275px', marginLeft: '10px' }}>
																	{isLoading ? (
																		<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
																	) : (
																		<span
																			className={`${
																				hasEveryPermission(['View Sales Orders Details']) ? 'cursor-pointer text-primary' : ''
																			}`}
																			onClick={() => {
																				if (hasEveryPermission(['View Sales Orders Details'])) {
																					viewData('sales_order', shipment?.sales_order?.id);
																				}
																			}}
																		>
																			{shipment?.sales_order?.sales_order_number ?? '-----'}
																		</span>
																	)}
																</div>
															</div>
														</div>
														<div className="col-md-8 col-12 form-group">
															<div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
																<div className="textGray" style={{ width: '151px' }}>
																	Invoice
																</div>
																<div style={{ maxWidth: '275px', marginLeft: '10px' }}>
																	{isLoading ? (
																		<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
																	) : (
																		<span
																			className={`${
																				hasEveryPermission(['View Estimation (Button)']) ? 'cursor-pointer text-primary' : ''
																			}`}
																			onClick={() => {
																				if (hasEveryPermission(['View Estimation (Button)'])) {
																					viewData('invoice', shipment?.invoice?.id);
																				}
																			}}
																		>
																			{shipment?.invoice?.invoice_number ?? '-----'}
																		</span>
																	)}
																</div>
															</div>
														</div>
													</div>

													<div className="row align-items-top">
														<div className="col-md-4 col-12 form-group">
															<div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
																<div className="textGray" style={{ width: '151px' }}>
																	Customer
																</div>
																<div style={{ maxWidth: '275px', marginLeft: '10px' }}>
																	{isLoading ? (
																		<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
																	) : (
																		<span
																			className={`${
																				hasEveryPermission(['View Contact (Button)']) ? 'cursor-pointer text-primary' : ''
																			}`}
																			onClick={() => {
																				if (hasEveryPermission(['View Contact (Button)'])) {
																					viewData('contact', shipment?.receiver?.id);
																				}
																			}}
																		>
																			{shipment?.receiver?.name ?? '-----'}
																		</span>
																	)}
																</div>
															</div>
														</div>
														<div className="col-md-8 col-12 form-group">
															<div style={{ display: 'flex', alignItems: 'center', textAlign: 'right' }}>
																<div className="textGray" style={{ width: '151px' }}>
																	Weight
																</div>
																<div style={{ maxWidth: '275px', marginLeft: '10px' }}>
																	{isLoading ? (
																		<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
																	) : (
																		<span>
																			{shipment?.weight ? (
																				`${shipment?.weight} ${shipment?.weight_unit}`
																			) : (
																				'-----'
																			)}
																		</span>
																	)}
																</div>
															</div>
														</div>
													</div>

													<div className="row align-items-top">
														<div className="col-12 form-group">
															<div style={{ display: 'flex', alignItems: 'center' }}>
																<div className="textGray" style={{ width: '151px', textAlign: 'right' }}>
																	Shipping Address
																</div>
																<div style={{ marginLeft: '10px' }}>
																	{isLoading ? (
																		<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
																	) : (
																		<span>
																			{shipment?.receiver?.address.address} {shipment?.receiver?.address.city}{' '}
																			{shipment?.receiver?.address.zipcode} {shipment?.receiver?.address.country}
																		</span>
																	)}
																</div>
															</div>
														</div>
													</div>

													{shippingDetails?.picklist?.id && (
														<PicklistComponent details={shippingDetails?.picklist} />
													)}
												</div>
											</div>
										</div>
									</div>
								))
							)}
							{shippingDetails?.shipments?.length > 0 && (
								<div className="row m-0">
									{shippingDetails?.shipments?.map((shipment, index) => (
										shipment?.attachments?.length > 0 && (
											shipment?.attachments?.map((attachment, index) => (
												attachment?.filename && (
													<div className="col-12 col-md-4" style={{ padding: '0px 5px' }}>
														<div className="card shadow-sm bg-white mb-4 w-100 border card-border-gray">
															<div className="card-header-radius-0">
																<div className="row">
																	<div className="col-11">
																		<div
																			className="text-primary cursor-pointer"
																			onClick={() => {
																				const url = `${attachment.attachment_url}`;
																				window.open(url, '_blank');
																			}}
																		>
																			{attachment?.filename}
																		</div>
																	</div>
																	<div className="col-1 text-right">
																		<div>
																			<button
																				className="btn modal-close-icon mt-19"
																				onClick={() => handleRemoveAttachment(attachment)}
																			>
																				<CloseIcon height={'16px'} width={'16px'} />
																			</button>
																		</div>
																	</div>
																</div>
															</div>
															<div className="card-body text-center">
																{attachment?.attachment_url && (
																	<>
																		{attachment?.extension == 'pdf' ? (
																			<PdfViewer src={attachment?.attachment_url + '#toolbar=0&navpanes=0&zoom=FitW'} />
																		) : (
																			<img src={attachment?.attachment_url} className="img-fluid" />
																		)}
																	</>
																)}
															</div>
														</div>
													</div>
												)
											))
										)
									))}
								</div>
							)}

							<div style={{ marginBottom: '8px' }}></div>
						</div>
					) : (
						<div className="mobile-scroll-container mobile-scroll-container-xsmaller" style={{ paddingTop: 10, gap: 10 }}>
							{shippingDetails?.shipments?.length > 0 && (
								<>
									{shippingDetails?.shipments?.map((shipment, index) => (
										<div key={index} className="m-0 p-3 p-xl-4 w-100 new-card">
											<div style={{ display: 'flex', flexDirection: 'column', width: '100%' }}>
												<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
													<div className="textGray">Reference</div>
													<div>{shipment?.reference_no}</div>
												</div>
												<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
													<div className="textGray">Picklist No</div>
													{isLoading ? (
														<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
													) : (
														<div
															className={`${hasEveryPermission(['View Picklists (Button)']) ? 'cursor-pointer text-primary' : ''}`}
															onClick={() => {
																if (hasEveryPermission(['View Picklists (Button)'])) {
																	viewData('picklist', shipment?.picklist?.id);
																}
															}}
														>
															{shipment?.picklist?.picklist_no ?? '-----'}
														</div>
													)}
												</div>
												<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
													<div className="textGray">Shipping Cost</div>
													{isLoading ? (
														<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
													) : (
														<div>
															{shipment?.shipping_cost ? (
																<CurrencyValue
																	currencyObject={shipment?.shipping_cost}
																	defaultCurrency={
																		selectedCurrency.replace(/\s+/g, '') === 'all'
																			? shippingDetails?.currency
																			: selectedCurrency.replace(/\s+/g, '')
																	}
																/>
															) : (
																'-----'
															)}
														</div>
													)}
												</div>
												<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
													<div className="textGray">Sales Order</div>
													{isLoading ? (
														<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
													) : (
														<div
															className={`${hasEveryPermission(['View Sales Orders Details']) ? 'cursor-pointer text-primary' : ''}`}
															onClick={() => {
																if (hasEveryPermission(['View Sales Orders Details'])) {
																	viewData('sales_order', shipment?.sales_order?.id);
																}
															}}
														>
															{shipment?.sales_order?.sales_order_number ?? '-----'}
														</div>
													)}
												</div>
												<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
													<div className="textGray">Invoice</div>
													{isLoading ? (
														<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
													) : (
														<div
															className={`${hasEveryPermission(['View Estimation (Button)']) ? 'cursor-pointer text-primary' : ''}`}
															onClick={() => {
																if (hasEveryPermission(['View Estimation (Button)'])) {
																	viewData('invoice', shipment?.invoice?.id);
																}
															}}
														>
															{shipment?.invoice?.invoice_number ?? '-----'}
														</div>
													)}
												</div>
												<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
													<div className="textGray">Customer</div>
													{isLoading ? (
														<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
													) : (
														<div
															className={`${hasEveryPermission(['View Contact (Button)']) ? 'cursor-pointer text-primary' : ''}`}
															onClick={() => {
																if (hasEveryPermission(['View Contact (Button)'])) {
																	viewData('contact', shipment?.receiver?.id);
																}
															}}
														>
															{shipment?.receiver?.name ?? '-----'}
														</div>
													)}
												</div>
												<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
													<div className="textGray">Weight</div>
													{isLoading ? (
														<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
													) : (
														<div>
															{shipment?.weight ? `${shipment?.weight} ${shipment?.weight_unit}` : '-----'}
														</div>
													)}
												</div>
												<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
													<div className="textGray" style={{ whiteSpace: 'nowrap' }}>
														Shipping Address
													</div>
													{isLoading ? (
														<Skeleton variant="rounded" width={'100%'} height={25} style={{ borderRadius: '12px'}} />
													) : (
														<div style={{ textAlign: 'right' }}>
															{shipment?.receiver?.address.address} {shipment?.receiver?.address.city}{' '}
															{shipment?.receiver?.address.zipcode} {shipment?.receiver?.address.country}
														</div>
													)}
												</div>
											</div>
										</div>
									))}
								</>
							)}
							{shippingDetails?.shipments?.length > 0 && (
								shippingDetails?.shipments?.map((shipment, index) => (
									shipment?.attachments?.length > 0 && (
										shipment?.attachments?.map((attachment, index) => (
											<div style={{display: 'flex', flexDirection: 'column', gap: 10, marginTop: 10}}>
												{attachment?.filename && (
													<div key={index} className="m-0 p-3 p-xl-4 w-100 new-card">
														<div style={{ display: 'flex', width: '100%', justifyContent: 'space-between', alignItems: 'center' }}>
															<div
																className="text-primary cursor-pointer"
																onClick={() => {
																	const url = `${attachment.attachment_url}`;
																	window.open(url, '_blank');
																}}
															>
																{attachment?.filename}
															</div>
															<div
																className="btn btn-danger btn-outlined-danger white-var btn-sm cursor-pointer"
																style={{ minWidth: 'unset' }}
																onClick={() => handleRemoveAttachment(attachment)}
															>
																<FiTrash2 size={20} />
															</div>
														</div>
													</div>
												)}
											</div>
										))
									)
								))
							)}

							<div style={{ marginBottom: '8px' }}></div>
						</div>
					)}
				</div>
			</div> */}

			{showTrackingNoModal && (
				<ShipmentTrackingModal
					shipmentId={showTrackingNoModal}
					shippingCompanies={shippingCompanies}
					redirectionData={redirectFunc}
					onFormSubmit={handleFormSubmit}
					handleCloseShipmentTrackingModal={handleCloseShipmentTrackingModal}
				/>
			)}

			{showAwbModal && (
				<AwbModal openPopup={showAwbModal} details={shippingDetails} handleClose={handleClose} handleReloadList={handleReloadList} />
			)}
			{showDeleteAttachmentPopup && (
				<DeleteConfirmation
					show={showDeleteAttachmentPopup}
					handleClose={handleClose}
					handleDelete={handleDeleteAttachment}
					title="Confirm"
					message={`Are you sure you want to delete ${selectedAttachment?.filename}?`}
					customDeleteButtonText={`Yes, Delete ${selectedAttachment?.filename}`}
				/>
			)}
			{showDeleteDataPopup && (
				<DeleteConfirmation
					show={showDeleteDataPopup}
					handleClose={() => {
						setShowDeleteDataPopup(false);
					}}
					handleDelete={handleDeleteData}
					title="Confirm"
					message={`Are you certain you wish to delete this shipping record? This action cannot be undone.`}
					customDeleteButtonText={`Yes, Delete Record`}
				/>
			)}
			{confirmationDialog?.show && (
				<ActionConfirmationModal
					show={confirmationDialog?.show}
					message={confirmationDialog?.message}
					title={confirmationDialog?.title}
					customConfirmText={confirmationDialog?.customConfirm || 'Confirm'}
					customCancelText={confirmationDialog?.customCancel || 'Cancel'}
					customIcon={<PiInfoFill />}
					handleConfirm={confirmationDialog?.handleConfirm}
					handleClose={confirmationDialog?.handleClose}
				/>
			)}
		</>
	);
}

export default ShipmentDetails;
